module.exports = __webpack_public_path__ + "img/logoseebpocosdecaldas.ba17f017.png";